'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Close = require('./Close');

var _Close2 = _interopRequireDefault(_Close);

var _AlertMessage = require('./AlertMessage');

var _AlertMessage2 = _interopRequireDefault(_AlertMessage);

var _AlertIcon = require('./AlertIcon');

var _AlertIcon2 = _interopRequireDefault(_AlertIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Alert = function Alert(props) {
  var level = props.level,
      message = props.message,
      className = props.className,
      close = props.close,
      onClickClose = props.onClickClose;


  return _react2.default.createElement(
    'div',
    { className: 'pxl-alert pxl-alert--' + level + ' ' + className },
    _react2.default.createElement(_AlertIcon2.default, { level: level }),
    _react2.default.createElement(_AlertMessage2.default, { msg: message }),
    _react2.default.createElement(_Close2.default, { onClick: onClickClose, close: close })
  );
};

Alert.propTypes = {
  className: _propTypes2.default.string,
  close: _propTypes2.default.bool,
  level: _propTypes2.default.oneOf(['danger', 'info', 'success', 'warning']).isRequired,
  message: _propTypes2.default.any.isRequired,
  onClickClose: _propTypes2.default.func
};

Alert.defaultProps = {
  className: '',
  level: 'danger'
};

exports.default = Alert;